import Vue from "vue";

// import component and stylesheet
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";

// see docs for available options
const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: "dddd, MMMM D, YYYY",
  days: [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ],
  daysShort: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
  monthNames: [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ],
  colors: {
    selected: "#7ac1e9", //7ac1e9
    inRange: "#7acfff",
    selectedText: "#fff",
    text: "#565a5c",
    inRangeBorder: "#7ac1e9", //7ac1e9
    disabled: "#fff",
    hoveredInRange: "#7acfff",
  },
  texts: {
    apply: "Applica",
    cancel: "Annulla",
    keyboardShortcuts: "Shortcuts",
  },
  //   ariaLabels: {
  //     chooseDate: (date) => date,
  //     chooseStartDate: (date) => `Choose ${date} as your start date.`,
  //     chooseEndDate: (date) => `Choose ${date} as your end date.`,
  //     selectedDate: (date) => `Selected. ${date}`,
  //     unavailableDate: (date) => `Not available. ${date}`,
  //     previousMonth: 'Move backward to switch to the previous month.',
  //     nextMonth: 'Move forward to switch to the next month.',
  //     closeDatepicker: 'Close calendar',
  //     openKeyboardShortcutsMenu: 'Open keyboard shortcuts menu.',
  //     closeKeyboardShortcutsMenu: 'Close keyboard shortcuts menu'
  //   },
  keyboardShortcuts: [
    {
      symbol: "↵",
      label: "Select the date in focus",
      symbolDescription: "Enter key",
    },
    {
      symbol: "←/→",
      label: "Move backward (left) and forward (right) by one day.",
      symbolDescription: "Left or right arrow keys",
    },
    {
      symbol: "↑/↓",
      label: "Move backward (up) and forward (down) by one week.",
      symbolDescription: "Up or down arrow keys",
    },
    {
      symbol: "PgUp/PgDn",
      label: "Switch months.",
      symbolDescription: "PageUp and PageDown keys",
    },
    {
      symbol: "Home/End",
      label: "Go to the first or last day of a week.",
      symbolDescription: "Home or End keys",
    },
    {
      symbol: "Esc",
      label: "Close this panel",
      symbolDescription: "Escape key",
    },
    {
      symbol: "?",
      label: "Open this panel",
      symbolDescription: "Question mark",
    },
  ],
};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
